import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Utils, getAppOrigin } from '../../utils';
import logo from '../../assets/notifysphere-logo.png';

const AdminForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);
        try {
            const response = await fetch(Utils.baseurl + 'admin/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: email.trim(),
                    origin: getAppOrigin()
                })
            });
            const result = await response.json();

            if (result.status) {
                setSuccess(result.message || 'If an account exists with this email, you will receive a password reset link shortly. Check your inbox and spam folder.');
            } else {
                setError(result.message || 'Something went wrong.');
            }
        } catch (err) {
            setError('Connection error. Please try again.');
        }
        setLoading(false);
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', width: '100%', maxWidth: '400px' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
                    <h2 style={{ margin: 0, color: '#1a1a1a' }}>Forgot password</h2>
                    <p style={{ color: '#6b7280', marginTop: '8px' }}>Enter your admin email and we'll send you a reset link</p>
                </div>

                {error && (
                    <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' }}>
                        {error}
                    </div>
                )}
                {success && (
                    <div style={{ background: '#d1fae5', color: '#059669', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' }}>
                        {success}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                            placeholder="admin@notifysphere.com"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%', padding: '14px', background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                            color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600',
                            cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
                        }}
                    >
                        {loading ? 'Sending...' : 'Send reset link'}
                    </button>

                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <button
                            type="button"
                            onClick={() => navigate('/admin/login')}
                            style={{
                                background: 'none', border: 'none', color: '#4f46e5', fontSize: '14px',
                                cursor: 'pointer', textDecoration: 'underline', padding: 0
                            }}
                        >
                            Back to Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminForgotPassword;
